var _defs, _circle, _mask, _g, _g2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSucceed = function SvgSucceed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Succeed_svg__b",
    width: 67.666,
    height: 64.667,
    x: -2.666,
    y: -16.667,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect_layerBlur_1",
    stdDeviation: 6.667
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Succeed_svg__c",
    width: 62.953,
    height: 67.034,
    x: -17.328,
    y: 0.08,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect_layerBlur_1",
    stdDeviation: 6.667
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#24961B"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "Succeed_svg__a",
    width: 48,
    height: 48,
    x: 0,
    y: 0,
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#00B42A"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#Succeed_svg__b)",
    mask: "url(#Succeed_svg__a)",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "evenodd",
    d: "m17.33 6.33.33 4.33 14 2L39 28l6-2-6-17.34-13-5.33z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#Succeed_svg__c)",
    mask: "url(#Succeed_svg__a)",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#466C4E",
    fillRule: "evenodd",
    d: "m24.92 46.23.7-4.29-13.13-5.24-3.52-16.63-6.3.54 1.75 18.25 11.37 8.25z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "evenodd",
    d: "m14.72 23.55 4.69 3.96c.34.28.83.27 1.16-.02l14.56-12.74c.49-.42 1.22-.4 1.68.06.47.47.48 1.24.02 1.72L21.49 32.45c-.81.84-2.16.82-2.96-.03l-6.05-6.52c-.63-.67-.57-1.74.13-2.34.61-.52 1.5-.52 2.11-.01"
  })));
};
export default SvgSucceed;